import styled from '@emotion/styled'
import React from 'react'
import newIconLogo from '../../assets/icons/new-logo-icon.png'
import hamburguerLogo from '../../assets/icons/icon-hamburger.svg'
import iconAgendamentoNormal from '../../assets/icons/icon-agendamento.svg'
import iconAgendamentoActive from '../../assets/icons/icon-agendar-yellow.svg'
import iconConsultarNormal from '../../assets/icons/icon-consultar-agendamento.svg'
import iconConsultarActive from '../../assets/icons/icon-consultar-yellow.svg'
import { useHistory } from 'react-router-dom'
export default function Menu({
  hiddenMenu,
  setHiddenMenu,
  pageActive,
  ...props
}: {
  hiddenMenu?: any
  setHiddenMenu?: any
  pageActive?: any
}) {
  const { Layout } = Menu
  return (
    <Layout {...props} hiddenMenu={hiddenMenu} className="container-side-menu">
      <ContainerLogo hiddenMenu={hiddenMenu} setHiddenMenu={setHiddenMenu} />
      <div className="divider-menu" />
      <ContainerNavigate pageActive={pageActive} hiddenMenu={hiddenMenu} />
    </Layout>
  )
}

Menu.Layout = styled.div<{ hiddenMenu: boolean }>(
  ({ hiddenMenu }) => `
  padding: 20px;
  min-width: 300px;
  background-color: #F7D047;
  .divider-menu {
    height: 2px;
    background-color: #EBBC00;
    margin: 20px 0px;
  }
  ${
    hiddenMenu &&
    `
    padding: 10px;
    min-width: 20px;
  `
  }
`
)

const ContainerLogo = ({
  hiddenMenu,
  setHiddenMenu,
}: {
  hiddenMenu: boolean
  setHiddenMenu: (value: boolean) => void
}) => {
  const { Flex, Logo, IconHamburger } = ContainerLogo

  return (
    <Flex hiddenMenu={hiddenMenu} className="container-side-menu-logo">
      {!hiddenMenu && <Logo src={newIconLogo} />}
      <IconHamburger src={hamburguerLogo} onClick={() => setHiddenMenu(!hiddenMenu)} />
    </Flex>
  )
}

ContainerLogo.Flex = styled.div<{ hiddenMenu: boolean }>(
  ({ hiddenMenu }) => `
  display: flex;
  justify-content: space-between;
  ${
    hiddenMenu &&
    `
    justify-content: center;
  `
  }
`
)
ContainerLogo.Logo = styled.img`
  width: 130px;
`

ContainerLogo.IconHamburger = styled.img`
  cursor: pointer;
`

const ContainerNavigate = ({
  pageActive,
  hiddenMenu,
}: {
  pageActive: string
  hiddenMenu: boolean
}) => {
  const { Layout, Navigate } = ContainerNavigate
  const history = useHistory()
  if (hiddenMenu) return null
  return (
    <Layout className="container-side-menu-navigate">
      <Navigate active={pageActive === 'agendar'}>
        <NavigateContent
          text="Agendar"
          imgIcon={pageActive === 'agendar' ? iconAgendamentoActive : iconAgendamentoNormal}
        />
      </Navigate>
      <Navigate
        onClick={() => history.push('/agendamentos/consultar')}
        active={pageActive === 'consultar'}
      >
        <NavigateContent
          text="Consultar"
          imgIcon={pageActive === 'consultar' ? iconConsultarActive : iconConsultarNormal}
        />
      </Navigate>
    </Layout>
  )
}

ContainerNavigate.Layout = styled.div`
  display: grid;
  gap: 20px;
  justify-content: center;
`
ContainerNavigate.Navigate = styled.div<{ active: boolean }>(
  ({ active }) => `
  width: 200px;
  display: flex;
  gap: 5px;
  color: #292926;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  justify-content: center;
  padding: 12px 0px;
  border-radius: 8px;
  ${
    active &&
    `
    background-color: #292926;
    color: #F7D047;
  `
  }
`
)

const NavigateContent = ({ text, imgIcon }: { text: string; imgIcon: any }) => {
  const { Layout } = NavigateContent
  return (
    <Layout className="container-side-menu-navigate-content">
      <img src={imgIcon} />
      <span>{text}</span>
    </Layout>
  )
}

NavigateContent.Layout = styled.div`
  display: flex;
  gap: 5px;
`
